<script setup lang="ts">

import TheBottomSheet from '@/components/TheBottomSheet.vue'
import { type EcommerceItem } from '@/types/shared/player-config'
import StarsBalancePill from '@/components/StarsBalancePill.vue'
import type { EcommercePrizeCardItem } from '@/types/shop'
import type { Skin } from '@/types/skin'
import PaymentButtons from '@/components/PaymentButtons.vue'
import { useEcommercePrice } from '@/composables/game/ecommerce'

const props = defineProps<{
	show: boolean
	skin: Skin
	item: EcommerceItem | EcommercePrizeCardItem
}>()
const emit = defineEmits<{
	(e: 'hide'): void
	(e: 'onPurchase'): void
}>()

const { getStarPrice } = useEcommercePrice()

const starPrice = getStarPrice(props.item)

function handlePurchase(paid: boolean) {
  if (paid) {
    emit('onPurchase')
  }
}

</script>

<template>
  <TheBottomSheet
    v-if="item"
    :show="show"
    @hide="$emit('hide')"
  >
    <div class="w-full flex flex-col items-center gap-y-12 relative">
      <StarsBalancePill
        class="absolute left-0 -top-6"
      />
      <div class="flex flex-col items-center gap-y-6">
        <div class="h-[88px] w-auto">
          <img
            :src="skin.imageUrl"
            :alt="skin.name"
            class="object-contain max-w-full max-h-full"
          >
        </div>
        <div class="flex text-center max-w-[360px] text-2xl font-bold -tracking-[0.48px] text-light-white">
          {{ skin.name }} = ${{ starPrice?.usdAmount }}
        </div>
      </div>
      <PaymentButtons
        :item="item"
        @purchase="({ paid }) => handlePurchase(paid)"
      />
    </div>
  </TheBottomSheet>
</template>
